import { createIcon } from '@chakra-ui/react';

export const ViewOff = createIcon({
  displayName: 'ViewOff',
  viewBox: '0 0 24 24',
  path: [
    <path
      clip-rule="evenodd"
      fill="currentColor"
      fill-rule="evenodd"
      key="right-hand-side"
      d="M20.79 4.88998L17.79 7.88998L17.8468 7.92682C19.4404 9.02144 20.8352 10.3844 22 11.9999C22 11.9999 18 17.9999 12 17.9999H11.9977C10.7114 17.9941 9.48521 17.7337 8.42996 17.2899L4.90997 20.7999C4.81094 20.915 4.66362 20.9886 4.49987 20.9886C4.36603 20.9886 4.24356 20.9399 4.14997 20.8599C4.05744 20.7661 4.00034 20.6372 4.00034 20.4949C4.00034 20.3527 4.05747 20.2238 4.14997 20.1299L20.1496 4.13032C20.2419 4.04614 20.3651 3.99451 20.5 3.99451C20.635 3.99451 20.7579 4.04598 20.85 4.12994C20.9306 4.22432 20.9787 4.34604 20.9787 4.47985C20.9787 4.64363 20.9058 4.79035 20.79 4.88998ZM12.0195 16.9995C14.5647 16.8992 16.8705 15.8673 18.6 14.2401L18.621 14.2224C19.293 13.6411 19.9179 13.0067 20.51 12.3001L20.76 12.0001L20.51 11.7001L20.489 11.6744C19.9179 10.9935 19.2931 10.3591 18.6 9.76007L18.6163 9.77417C18.1531 9.3672 17.664 8.98917 17.1 8.6101L14 11.7001V12.0001C14 13.1047 13.1046 14.0001 12 14.0001H11.7L9.18 16.5001L9.12103 16.4811C10.0185 16.8109 10.9869 16.9936 12 17.0001L12.0195 16.9995Z"
    />,
    <path
      d="M6.56 16.31L7.28 15.59C6.56925 15.1629 5.9549 14.7172 5.38194 14.2248L5.39997 14.24C4.70694 13.6409 4.08209 13.0066 3.51094 12.3257L3.48997 12.3L3.23997 12L3.48997 11.7C4.08209 10.9934 4.70694 10.359 5.379 9.77773L5.4 9.75998C7.12862 8.13129 9.43493 7.09891 11.9809 7.00057L12 6.99998C13.1424 7.00639 14.2294 7.23636 15.2217 7.64829L15.22 7.64998L15.2759 7.67101L15.2217 7.64829L16 6.89998C14.8281 6.33913 13.4537 6.0081 12.0028 6.00001L12 5.99998C6 5.99998 2 12 2 12C3.24597 13.715 4.75965 15.1491 6.49447 16.2703L6.56 16.31Z"
      fill="currentColor"
      key="outer-circle"
    />,
    <path
      d="M9.99999 12C9.99999 10.8954 10.8954 9.99998 12 9.99998C12.2596 10.0026 12.5077 10.0574 12.72 10.1499L10.15 12.7199L10.1547 12.7322C10.0575 12.5077 10.0026 12.2606 9.99999 12Z"
      fill="currentColor"
      key="inner-circle"
    />,
  ],
});
